export function dataFiltered() {
  return (dispatch, getState) => {
    const state = getState()
    dispatch({type: "DATA_FILTERED", filteredData: state.DataApp.get('filteredData'), filteredLocations: state.DataApp.get('filteredLocations') })
  }
}

export const toggleCheckBox = (id, list) => ({
  type: "TOGGLE_CHECK_BOX",
  id,
  list
})

export const initializeCarveOuts = () => ({
  type: "INIT_CARVE_OUTS"
})



// WEBPACK FOOTER //
// ./src/actions/data.js